export default __webpack_public_path__ + "static/media/refresh.f16d19ee.svg";